import { BooleanValueProperty } from './properties/boolean-property.model';
import { PrintProperty } from './properties/print-property.model';
import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';

export class CbRicheditWidget extends Widget {
  constructor(data: any = {}) {
    super(data);
    this.title = 'Formatted Text';
    this.name = 'cb-richedit';
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any = {}) {
    const properties = {
      text: new TextProperty({
        value: props.text ? props.text.value : '',
      }),
      value: new TextProperty(props.value || 'Sample content'),
      hideLabel: new BooleanValueProperty({
        value: props.hideLabel ? props.hideLabel.value : false,
      }),
      printing: new PrintProperty(props.printing ? props.printing : {}),
    };
    return properties;
  }
}
